module.exports = __webpack_public_path__ + "static/bg_full-8dc36f98ebf0fb45dd1df85986cbb0ff.jpg";